import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { getSurveyResponses } from '../Services/Surveys.service';
import type { SurveyResponsesRequest } from '../Types/Surveys.types';

/**
 * One page of respondents, every status by default.
 *
 * It is the only place `daysSinceAnchor` arrives per person, which is what lets the results
 * screen split respondents into cohorts of feature use (R17).
 */
export const useSurveyResponses = (
  id: string | undefined,
  params: SurveyResponsesRequest,
  enabled = true,
) =>
  useQuery({
    queryKey: surveysQueryKeys.responses(id ?? '', params),
    queryFn: () => getSurveyResponses(id ?? '', params),
    enabled: Boolean(id) && enabled,
    placeholderData: keepPreviousData,
  });
